import React, { useState } from 'react'
import { truncateString } from '../../../services/helpers/helpers'

const AssessmentCard = ({ item, index }) => {

    const truncatedDesc = truncateString(item.desc)
    const [desc, setdesc] = useState(truncatedDesc)

    const [expand, setexpand] = useState(false)
    const handleExpand = () => {
        if (expand === false) {
            setdesc(item.desc)
        } else {
            const truncatedDesc = truncateString(item.desc) 
            setdesc(truncatedDesc)
        }
        setexpand(!expand)
    }



    return (
        <div key={`divSmallCard${item.heading}${index}`} className="flex justify-center w-[18rem] sm:w-[10rem] sm:mx-3 lg:w-[18rem] m-5 2xl:w-[425px] !ml-4">
            <div className="block rounded-lg shadow-lg bg-[#F6F6F6]  max-w-sm text-center 2xl:p-2">
                <div className="py-3 px-6 border-b border-gray-300 font-bold text-left text-lg sm:text-sm sm:px-3 2xl:text-[30px] 2xl:leading-[32px] 2xl:font-[600]">
                    {item.heading}
                </div>
                <div className="p-6 sm:p-3">
                    <div className="text-gray-700 text-sm mb-4 text-left sm:text-xs 2xl:text-[16px] 2xl:leading-[28px]">
                        {desc}
                    </div>
                    <div className="readMore text-smlg 2xl:text- text-left font-bold text-[#474747] cursor-pointer" onClick={handleExpand}>{expand === true ? "Read Less" : "Read More.."}</div>

                </div>
                <div className="py-3 px-4 border-t border-gray-300 text-gray-600">

                </div>
            </div>
        </div>
    )
}

export default AssessmentCard